import { identity } from "lodash";
import axiosInstance from "../AxiosInstance";
import {
  ABOUT,
  ADDEDUCATION,
  APPOINTMENTSREFERAL,
  CASEREFERAL,
  CATEOGRY,
  DASHBOARDS_PEAK,
  DASHBOARDS_STATS,
  DELETE,
  EDITVENDORCATEGORY,
  FAQ,
  FILEUPLAOD,
  FILEURL,
  GET_CONTRACTS,
  INDIVIDUAL_CHAT,
  LEGAL,
  PRIVACY_POLICY,
  PRIVACYPOLICY,
  PROMOTION,
  RESOURCES,
  SEARCH,
  SERVICE,
  SUBADMIN,
  TERMSCONDITIONS,
  UPDATE_ABOUT,
  FLAT_DETAIL,
  UPDATE_POLICY,
  UPDATE_TERMSCONDITIONS,
  USER_CHATS,
  VENDOR,
  VENDORREQUEST,
  VERIFYUSER,
  DELETE_AD,
} from "./adminEndpoints";

export function postServices(payload) {
  return axiosInstance.post(SERVICE, payload);
}
export function getServices(limit, page, search) {
  let url = `${SERVICE}`;
  const params = [];

  if (limit && limit !== "") {
    params.push(`limit=${encodeURIComponent(limit)}`);
  }

  if (page && page !== "") {
    params.push(`page=${encodeURIComponent(page)}`);
  }

  if (search && search.trim() !== "") {
    params.push(`search=${encodeURIComponent(search.trim())}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

export function deleteServices(id) {
  return axiosInstance.delete(`${SERVICE}?serviceId=${id}`);
}

export function editServices(payload) {
  return axiosInstance.put(SERVICE, payload);
}

export function getFaQs(page, limit, search) {
  let url = `${FAQ}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function deleteFaQs(id) {
  return axiosInstance.delete(`${FAQ}?faqId=${id}`);
}

export function editFAQ(payload) {
  return axiosInstance.put(FAQ, payload);
}

export function addFAQ(payload) {
  return axiosInstance.post(FAQ, payload);
}

export function getInfo() {
  return axiosInstance.get(LEGAL);
}

export function createInfo(payload) {
  return axiosInstance.post(LEGAL, payload);
}

export function getResources() {
  return axiosInstance.get(RESOURCES);
}

export function createResources(payload) {
  return axiosInstance.post(RESOURCES, payload);
}

export function addFile(payload) {
  return axiosInstance.put(FILEUPLAOD, payload);
}
export function getUrl(payload) {
  return axiosInstance.get(`${FILEURL}?link=${payload}`);
}

export function addEducation(payload) {
  return axiosInstance.post(ADDEDUCATION, payload);
}

export function getEducation(page, limit, type, search) {
  let url = `${ADDEDUCATION}?page=${page}&limit=${limit}&type=${type}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function deleteEducation(id) {
  return axiosInstance.delete(`${ADDEDUCATION}?educationId=${id}`);
}

export function updateEducation(payload) {
  return axiosInstance.put(ADDEDUCATION, payload);
}

export function getPrivayPolicy() {
  return axiosInstance.get(PRIVACYPOLICY);
}

export function createPrivayPolicy(payload) {
  return axiosInstance.post(PRIVACYPOLICY, payload);
}
export function deletePrivayPolicy(id) {
  return axiosInstance.delete(`${PRIVACYPOLICY}?privacyPolicyId=${id}`);
}

export function updatePrivayPolicy(payload) {
  return axiosInstance.put(PRIVACYPOLICY, payload);
}

export function getTermsConditions() {
  return axiosInstance.get(TERMSCONDITIONS);
}

export function createTermsConditions(payload) {
  return axiosInstance.post(TERMSCONDITIONS, payload);
}
export function deleteTermsConditions(id) {
  return axiosInstance.delete(`${TERMSCONDITIONS}?termId=${id}`);
}

export function updateTermsConditions(payload) {
  return axiosInstance.put(UPDATE_TERMSCONDITIONS, payload);
}

export function getAbout() {
  return axiosInstance.get(ABOUT);
}

export function createAbout(payload) {
  return axiosInstance.post(ABOUT, payload);
}
export function deleteAbout(id) {
  return axiosInstance.delete(`${ABOUT}?aboutId=${id}`);
}

export function updateAbout(payload) {
  return axiosInstance.put(UPDATE_ABOUT, payload);
}

export function getPolicy() {
  return axiosInstance.get(PRIVACY_POLICY);
}
export function updatePolicy(payload) {
  return axiosInstance.put(UPDATE_POLICY,payload);
}

export function getPromotion(page, limit, search) {
  let url = `${PROMOTION}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function createPromotion(payload) {
  return axiosInstance.post(PROMOTION, payload);
}
export function deletePromotion(id) {
  return axiosInstance.delete(`${PROMOTION}?promotionId=${id}`);
}

export function updatePromotion(payload) {
  return axiosInstance.put(PROMOTION, payload);
}

export function getSearch(page, limit, search) {
  let url = `${SEARCH}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function createSearch(payload) {
  return axiosInstance.post(SEARCH, payload);
}
export function deleteSearch(id) {
  return axiosInstance.delete(`${CATEOGRY}/deleteCategory?id=${id}`);
}

export function updateSearch(payload) {
  return axiosInstance.put(`${CATEOGRY}/editCategory`, payload);
}

export function getReferal(page, limit, search) {
  let url = `${CASEREFERAL}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function getReferalDetail(id) {
  let url = `admin/case-referral/details?id=${id}`;

  return axiosInstance.get(url);
}

export function updateReferalDetail(payload) {
  let url = `${CASEREFERAL}/update-status`;

  return axiosInstance.put(url, payload);
}

export function getAppointments(
  page,
  limit,
  search,
  statusFilter,
  startDate,
  endDate,
  serviceDepartment,
) {
  let url = `${APPOINTMENTSREFERAL}?page=${page}&limit=${limit}`;

  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (statusFilter) {
    url += `&status=${encodeURIComponent(statusFilter)}`;
  }

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }

  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }

  if (serviceDepartment) {
    url += `&serviceDepartment=${encodeURIComponent(serviceDepartment)}`;
  }
  return axiosInstance.get(url);
}

export function getAppointmentsById(id) {
  let url = `${APPOINTMENTSREFERAL}/details?appointmentId=${id}`;

  // if (search && search.trim() !== "") {
  //   url += `&search=${encodeURIComponent(search)}`;
  // }
  return axiosInstance.get(url);
}

export function updateAppointentStatus(paylaod) {
  let url = `${APPOINTMENTSREFERAL}`;

  // if (search && search.trim() !== "") {
  //   url += `&search=${encodeURIComponent(search)}`;
  // }
  return axiosInstance.put(url, paylaod);
}

export function getSTATS(start, end) {
  let url = `${DASHBOARDS_STATS}`;
  const params = [];

    
  if (start) params.push(`startDate=${start}`);
  if (end) params.push(`endDate=${end}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

export function getPEAK(groupBy, start, end) {
  let url = `${DASHBOARDS_PEAK}`;
  const params = [];

  if (groupBy) params.push(`groupBy=${groupBy}`);
  if (start) params.push(`startDate=${start}`);
  if (end) params.push(`endDate=${end}`);

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return axiosInstance.get(url);
}

//getDepartments
export function getDepartments() {
  let url = `admin/department`;
  return axiosInstance.get(url);
}

//get SubAdmin
export function getSubAdmins(
  page,
  limit,
  activeTab,
  category,
  search,
  startDate,
  endDate,
) {
  let url = `${SUBADMIN}?page=${page}&limit=${limit}&type=${activeTab}`;

  if (category && category.trim() !== "") {
    url += `&category=${encodeURIComponent(category)}`;
  }
  if (startDate && startDate.trim() !== "") {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate && endDate.trim() !== "") {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}
export function updateAdminStatus(payload) {
  let url = `/admin/userAction`;
  return axiosInstance.put(url, payload);
}

export function updateListingStatus(payload) {
  let url = `/admin/actionOnAds`;
  return axiosInstance.put(url, payload);
}

export function createNewAdmin(payload) {
  let url = `${SUBADMIN}/create`;
  return axiosInstance.post(url, payload);
}
export function updateAdminInfo(payload) {
  let url = `/admin/editUser`;
  return axiosInstance.put(url, payload);
}

export function deleteAdmin(id,payload) {
  let url = `${DELETE}?id=${id}&reason=${payload}`;
  return axiosInstance.delete(url);
}

 export function deleteAds(id,payload) {
  let url = `${DELETE_AD}?id=${id}&reason=${payload}`;
  return axiosInstance.delete(url);
}
 
export function updatePermission(payload) {
  let url = `${SUBADMIN}/update-permissions`;
  return axiosInstance.put(url, payload);
}

//vendor
export function getFavVendor(
  id,
  page,
  limit,
  category,
  startDate,
  endDate,
  search,
) {
  let url = `${VENDOR}?userId=${id}&page=${page}&limit=${limit}&category=${category}&startDate=${startDate}&endDate=${endDate}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}
export function vendorRequest(payload) {
  let url = `${VENDORREQUEST}`;
  return axiosInstance.put(url, payload);
}
export function verifyUser(payload) {
  let url = `${VERIFYUSER}`;
  return axiosInstance.put(url, payload);
}
export function vendorCategory(payload) {
  let url = `${EDITVENDORCATEGORY}`;
  return axiosInstance.put(url, payload);
}

//catefgory;
export function getCategory(page, limit, search) {
  let url = `${CATEOGRY}/getCategories?page=${page}&limit=${limit}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

//user chat

export function getChats(page, limit, id, search, category) {
  let url = `${USER_CHATS}?page=${page}&limit=${limit}&userId=${id}&category=${category}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search)}`;
  }
  return axiosInstance.get(url);
}

export function getIndividualChat(id,page,limit) {
  let url = `${INDIVIDUAL_CHAT}?conversationId=${id}&page=${page}&limit=${limit}`;
  return axiosInstance.get(url);
}

export function getContracts(id,page,limit) {
  let url = `${GET_CONTRACTS}?conversationId=${id}&page=${page}&limit=${limit}`;
  return axiosInstance.get(url);
}



export function getFlatById(id) {
  let url = `${FLAT_DETAIL}?id=${id}`;
  return axiosInstance.get(url);
}

